import * as React from 'react';
import ProjectLayout from '../ProjectLayout';
import { useMsgText } from '../../localization/hooks';
import { Str } from '../../localization/translationKeys';
import SurveyHeader from '../survey/SurveyHeader';
import { css } from '@emotion/core';
import { COLORS } from '../../globalStyle/colors';
import { onMobileDevice } from '../../globalStyle/mediaQueries';
import { useAppState } from '../../core/redux/hooks';
import * as R from 'ramda';
import { useMount } from '../../core/hooks/useMount';
import { useDispatch } from 'react-redux';
import { getEBookUrlAction } from '../api/getEBookUrlAction';
import { useProjIds } from '../../navigation/hooks';
import { Loader } from '../../loading/Loader';
import Msg from '../../localization/Msg';


const styles = {
  content:       css`
    margin-top: 62px;
    background-color: ${COLORS.WHITE};
    width: 100%;

    ${onMobileDevice} {
      margin-top: 20px;
    }
  `,
  header: css`
    ${onMobileDevice} {
      margin-top: 37px;
    }  
  `,
  loader:        css`
    width: 150px;
    height: 150px;
    margin: auto;
  `,
  iframe:        css`
    width: 100%;
    height: calc(100vh - 53px);
  `,  
  notFoundRow:   css`
    margin: 70px 50px;
  `,
  notFound:      css`
    font-size: 16px;
  `,
  availabilityMessage: css`
    margin-top: 37px;
    display: block;
  `,
};


type Props = {
  className?: string;
};


/**
 * EBook: a component that displays an EBook from VitalSource
 *
 * PureComponent: true
 * Redux Connected: false
 */
const EBook: React.FC<Props> = props => {
  const pageTitle = useMsgText(Str.EBook);

  const dispatch = useDispatch();

  const projIds       = useProjIds();
  const participantId = projIds.participantId;
  const project       = useAppState(state => state.projectSummary);
  const projectId     = projIds.projId;
  const url           = useAppState(state => state.eBookUrl);

  const useUrl = React.useMemo(() => url, [url]);

  useMount(() => {
    // always get new URL since they are only valid for 2 minutes
    dispatch(getEBookUrlAction(projectId, participantId));
  });

  return (
    <ProjectLayout className={props.className}>
      <SurveyHeader title={`/ ${pageTitle}`} deadline={undefined} css={styles.header}/>

      {
        project?.reportAvailable
        ? R.isNil(useUrl)
            ?  <Loader css={styles.loader} />
            : <iframe
                frameBorder={0}
                css={styles.iframe}
                src={url}
                title='e-book'
              />
        : <Msg defaultMsg='X' str={Str.EBookAvailability} css={styles.availabilityMessage} />
      }
    </ProjectLayout>
  )

};

export default EBook;
